export default __webpack_public_path__ + "static/media/RobotoMono500.82de72df.woff";